import React from "react";

const STYLES = {
  PAGADO: "bg-[#DAE6D7] text-[#3F6B3C] border-[#BCD3B7]",
  PARCIAL: "bg-[#FDF3E1] text-[#A6751F] border-[#F0DEB2]",
  CUENTA_CORRIENTE: "bg-[#F4EAE6] text-[#A64A29] border-[#E8C9BB]",
  NO_PAGADO: "bg-[#F0F0F0] text-[#595959] border-[#E0E0E0]",
};

const LABELS = {
  PAGADO: "Pagado",
  PARCIAL: "Parcial",
  CUENTA_CORRIENTE: "Cta. Corriente",
  NO_PAGADO: "No pagado",
};

export default function EstadoPagoBadge({ estado, className = "" }) {
  if (!estado) return null;
  const cls = STYLES[estado] || STYLES.NO_PAGADO;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-[0.1em] border ${cls} ${className}`}
      data-testid={`estado-pago-${estado}`}
    >
      {LABELS[estado] || estado}
    </span>
  );
}
